S.toggleModule = {
    elements: {
        $item: null,
    },

    init()
    {
        this.elements.$item.on('click', (event) =>
        {
            let target = $(event.target).closest('.m-item');
            let label = $(target).find('label');
            let content = $(target).find('.m-text');
            target.toggleClass('is-active');
            label.toggleClass('is-active');
            content.toggleClass('is-active');

            this.elements.$item.each(function (i, e)
            {
                if (e !== target[0])
                {
                    let label = $(e).find('label');
                    let content = $(e).find('.m-text');
                    label.removeClass('is-active');
                    content.removeClass('is-active');
                    e.classList.remove('is-active');
                }
            });
        });
    },
};
